import React from 'react';
import styled from 'styled-components';
import { Responsive } from 'semantic-ui-react';

const Container = styled.div`
  position: absolute;
  top: 40px;
  right: 20px;
`;

const MobileContainer = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
`;

const URL =
  'https://itunes.apple.com/us/app/popshop-start-shopping-us/id1009480270?ls=1&mt=8';

export default () => {
  return (
    <>
      <Responsive minWidth={641}>
        <Container>
          <a rel="noopener noreferrer" target="_blank" href={URL}>
            <img
              alt="appstore"
              src={require('../assets/images/appstore.png')}
            />
          </a>
        </Container>
      </Responsive>
      <Responsive maxWidth={640}>
        <MobileContainer>
          <a rel="noopener noreferrer" target="_blank" href={URL}>
            <img
              width="118"
              alt="appstore"
              src={require('../assets/images/appstore.png')}
            />
          </a>
        </MobileContainer>
      </Responsive>
    </>
  );
};
